import { defineMessages } from 'react-intl';

export default defineMessages({
    whereDidThisHappen: {
        id: 'fnol.common.directives.loss-location.Where did this happen?',
        defaultMessage: 'Where did this happen?'
    },
    policyLocation: {
        id: 'fnol.common.directives.loss-location.Policy Location',
        defaultMessage: 'Policy Location'
    },
    lossIncidentLocation: {
        id: 'fnol.common.directives.loss-location.Loss/Incident Location',
        defaultMessage: 'Loss/Incident Location'
    },
    fnolUseMyPolicyAddress: {
        id: 'fnol.common.directives.loss-location.Use my policy address',
        defaultMessage: 'Use my policy address'
    },
    fnolSpecifyFullAddress: {
        id: 'fnol.common.directives.loss-location.Specify full address manually',
        defaultMessage: 'Specify full address manually'
    },
    fnolKnowCity: {
        id: 'fnol.common.directives.loss-location.I just know the city',
        defaultMessage: 'I just know the city'
    },
    fnolLocationMap: {
        id: 'fnol.common.directives.loss-location.Choose location on a map',
        defaultMessage: 'Choose location on a map'
    },
    fnolSelectAddress: {
        id: 'fnol.common.directives.loss-location.Select Address',
        defaultMessage: 'Select Address'
    },
    fnolChooseAddress: {
        id: 'fnol.common.directives.loss-location.-- Choose Address --',
        defaultMessage: '-- Choose Address --'
    },
    fnolProvideAddress: {
        id: 'fnol.common.directives.loss-location.Please provide an address.',
        defaultMessage: 'Please provide an address.'
    },
    fnolMapLocation: {
        id: 'fnol.common.directives.loss-location.Click anywhere on the map to set a location or drag the pin to adjust it.',
        defaultMessage: 'Click anywhere on the map to set a location or drag the pin to adjust it.'
    },
    city: {
        id: 'fnol.common.directives.loss-location.City',
        defaultMessage: 'City'
    },
    cityOrWater: {
        id: 'fnol.common.directives.loss-location.City or Body of Water',
        defaultMessage: 'City or Body of Water'
    },
    unknowTips: {
        id: 'fnol.common.directives.loss-location.unknowTips',
        defaultMessage: 'If you don\'t know specific {what}, please enter \'Unknown\''
    },
    addressLine1: {
        id: 'fnol.common.directives.loss-location.Address Line 1',
        defaultMessage: 'Address Line 1'
    },
    addressLineStreet1: {
        id: 'fnol.common.directives.loss-location.Address Line 1/Cross Street',
        defaultMessage: 'Address Line 1/Cross Street'
    },
    addressLine2: {
        id: 'fnol.common.directives.loss-location.Address Line 2',
        defaultMessage: 'Address Line 2'
    },
    addressLineStreet2: {
        id: 'fnol.common.directives.loss-location.Address Line 2/Cross Street',
        defaultMessage: 'Address Line 2/Cross Street'
    },
    addressLine3: {
        id: 'fnol.common.directives.loss-location.Address Line 3',
        defaultMessage: 'Address Line 3'
    },
    addressLineStreet3: {
        id: 'fnol.common.directives.loss-location.Address Line 3/Cross Street',
        defaultMessage: 'Address Line 3/Cross Street'
    },
    province: {
        id: 'fnol.common.directives.loss-location.Province',
        defaultMessage: 'Province'
    },
    postalCode: {
        id: 'fnol.common.directives.loss-location.Postal Code',
        defaultMessage: 'Postal Code'
    },
    state: {
        id: 'fnol.common.directives.loss-location.State',
        defaultMessage: 'State'
    },
    zipCode: {
        id: 'fnol.common.directives.loss-location.ZIP Code',
        defaultMessage: 'ZIP Code'
    }
});
